module.exports = __webpack_public_path__ + "img/组5114@2x.2cdebf36.png";